export const API_BASE_URL =
  process.env.REACT_APP_ENV === "production"
    ? process.env.REACT_APP_API_BASE_URL || "https://api.vspn.app/api/v1"
    : "http://localhost:8000/api/v1";

export const IS_NBA_MODE = true;
